import { render } from "./UIDropdown.vue?vue&type=template&id=23421e90"
import script from "./UIDropdown.vue?vue&type=script&lang=js"
export * from "./UIDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__